

















import { Component, Vue, Watch } from "vue-property-decorator";
import Axios from "../../plugins/http";

@Component
export default class customeService extends Vue {
  service: any = {};

  created() {
    this.getCustomer();
  }

  getCustomer() {
    Axios.getSecret(`/api/common/customer/service`).then(
      ({ data: { data, status, msg } }) => {
        if (status === 200) {
          data.qqCode = decodeURIComponent(data.qqCode);
          this.service = data;
        } else {
          this.$message(msg);
        }
      }
    );
  }
  setCustomer() {
    Axios.postByQs(`/api/common/customer/save`, {
      ...this.service,
      qqCode: encodeURIComponent(this.service.qqCode)
    }).then(({ data: { data, status, msg } }) => {
      if (status === 200) {
        this.$message({
          type: "success",
          message: "保存成功"
        });
      } else {
        this.$message(msg);
      }
    });
  }
}
